module.exports = __webpack_public_path__ + "media/images/flags/ci-91bd6554ae53c032c081af3c3f4cb1cc.svg";